import send from "./send.svg"
import loader from "./loader.svg"
import eye from "./eye.svg"
import eyeOff from "./eye-off.svg"
import spinner from "./loading-load.gif"

export const IMAGES = {
    send,
    loader,
    eye,
    eyeOff,
    spinner
}